import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ExternalLink } from 'lucide-react';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Projects', path: '/projects' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Services', path: '/services' },
    { name: 'Core Strengths', path: '/core-strengths' },
    { name: 'Compliance', path: '/compliance' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="navigation-header">
      <div className="container">
        <div className="flex items-center justify-between">
          <Link to="/" className="navigation-logo-wrapper">
            <img 
              src="/pinnacle-logo.png" 
              alt="Pinnacle Biomed Logo" 
              className="navigation-logo-image"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            <ul className="navigation-menu">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className={`navigation-link ${isActive(item.path) ? 'active' : ''}`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
            <a
              href="http://pinnaclebiomed.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 px-4 py-2 text-sm font-medium"
              style={{
                background: 'var(--brand-orange)',
                color: 'white',
                borderRadius: '4px',
                textDecoration: 'none',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => e.currentTarget.style.background = 'var(--brand-teal)'}
              onMouseOut={(e) => e.currentTarget.style.background = 'var(--brand-orange)'}
            >
              Main Website <ExternalLink size={14} />
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className="lg:hidden mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t" style={{ borderColor: 'var(--border-light)', paddingTop: '16px' }}>
            <ul className="flex flex-col space-y-1">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className={`mobile-nav-link block py-3 px-2 ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{
                      fontSize: '16px',
                      fontWeight: '400',
                      color: isActive(item.path) ? 'var(--interactive-base)' : 'var(--text-primary)',
                      background: isActive(item.path) ? 'var(--bg-secondary)' : 'transparent',
                      transition: 'background 0.2s ease'
                    }}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="http://pinnaclebiomed.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mobile-nav-link flex items-center gap-2 py-3 px-2"
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    color: 'var(--brand-orange)',
                    transition: 'background 0.2s ease'
                  }}
                >
                  Visit Main Website <ExternalLink size={16} />
                </a>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
